module.exports = __webpack_public_path__ + "static/media/proj19_img4.61502cfa.jpg";